import { inject, Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { combineLatest, first, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'formatFormErrors',
    standalone: true,
})
export class FormatFormErrorsPipe implements PipeTransform {
    private readonly _translateService = inject(TranslateService);

    transform(value: ValidationErrors | undefined | null, fieldName = '') {
        if (value == null) return of('');

        if ('required' in value) {
            return this._translateService.get('messages.fieldIsRequired').pipe(map(m => `${fieldName} ${m}`));
        }

        if ('minlength' in value) {
            return combineLatest([
                this._translateService.get('messages.fieldShouldBeMinimum', {
                    number: value['minlength']['requiredLength'],
                }),
                this._translateService.get('general.symbols'),
            ]).pipe(
                map(([min, symbol]) => `${min} ${value['minlength']['actualLength']} ${symbol}.`),
                first()
            );
        }

        if ('errorMessage' in value) {
            return this._translateService.get(value['errorMessage']);
        }

        return of('');
    }
}
